// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { component } from 'picoapp';

import { dispatch } from '../../utils/theme';

export default component(async (node: HTMLElement, ctx: any) => {
  const buttons = node.querySelectorAll('button');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const value = button.dataset.value;

      ctx.emit('product-grid-view', { value });

      dispatch('filter-change-display', {
        value: button.getAttribute('data-tracking-id'),
      });

      buttons.forEach((item) => {
        item.className =
          (item.dataset.value === value ? item.dataset.activeClass : item.dataset.inactiveClass) ??
          '';
      });
    });
  });
});
